module.exports = __webpack_public_path__ + "img/91987.f85b8698.svg";